<app-users-table
  [utilizatori]="tables$ | async"
  [utilizatoriLength]="total$ | async"
  [loadingDataSpinner]="loadingDataSpinner"
  (filterData)="filterSearchData($event)"
  (tableCallback)="getTableCallback($event)"
  (pageSizeChanged)="changePageSize($event)"
  (pageNumberChanged)="changePageNumber($event)"
></app-users-table>
